module.exports = __webpack_public_path__ + "img/operator5.1744381b.png";